import type * as SchemaTypes from '../types';

import type { CurrentUserCompaniesDataFragment } from '../fragments/CurrentUserCompaniesData';
import type { UserCompanyContextDataFragment } from '../fragments/UserCompanyContextData';
import type { TranslatedStringDataFragment } from '../fragments/TranslatedStringData';
import type { LanguagePackContextDataFragment } from '../fragments/LanguagePackContextData';
import type { UploadFileWithPreviewFormDataFragment } from '../fragments/UploadFileWithPreviewFormData';
import type { AvailableModulesDataFragment } from '../fragments/AvailableModulesData';
import type { CompanyDealerDataFragment } from '../fragments/CompanyDealerData';
import type { MaintenanceUpdateFragment } from '../fragments/MaintenanceUpdate';
import type { SimpleVersioningDataFragment } from '../fragments/SimpleVersioningData';
import type { AuthorData_CorporateCustomer_Fragment, AuthorData_ExternalBank_Fragment, AuthorData_Guarantor_Fragment, AuthorData_LocalCustomer_Fragment, AuthorData_Salesforce_Fragment, AuthorData_SystemBank_Fragment, AuthorData_User_Fragment } from '../fragments/AuthorData';
import type { UserAvatarSpecsFragment } from '../fragments/UserAvatarSpecs';
import type { EdmEmailFooterPublicDataFragment } from '../fragments/EdmEmailFooterPublicData';
import type { EdmSocialMediaDataFragment } from '../fragments/EdmSocialMediaData';
import { gql } from '@apollo/client';
import { CurrentUserCompaniesDataFragmentDoc } from '../fragments/CurrentUserCompaniesData';
import { UserCompanyContextDataFragmentDoc } from '../fragments/UserCompanyContextData';
import { TranslatedStringDataFragmentDoc } from '../fragments/TranslatedStringData';
import { LanguagePackContextDataFragmentDoc } from '../fragments/LanguagePackContextData';
import { UploadFileWithPreviewFormDataFragmentDoc } from '../fragments/UploadFileWithPreviewFormData';
import { AvailableModulesDataFragmentDoc } from '../fragments/AvailableModulesData';
import { CompanyDealerDataFragmentDoc } from '../fragments/CompanyDealerData';
import { MaintenanceUpdateFragmentDoc } from '../fragments/MaintenanceUpdate';
import { SimpleVersioningDataFragmentDoc } from '../fragments/SimpleVersioningData';
import { AuthorDataFragmentDoc } from '../fragments/AuthorData';
import { UserAvatarSpecsFragmentDoc } from '../fragments/UserAvatarSpecs';
import { EdmEmailFooterPublicDataFragmentDoc } from '../fragments/EdmEmailFooterPublicData';
import { EdmSocialMediaDataFragmentDoc } from '../fragments/EdmSocialMediaData';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAuthenticatedUserCompaniesQueryVariables = SchemaTypes.Exact<{
  companyId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['ObjectID']['input']>;
}>;


export type GetAuthenticatedUserCompaniesQuery = (
  { __typename: 'Query' }
  & { currentUser?: SchemaTypes.Maybe<(
    { __typename: 'User' }
    & CurrentUserCompaniesDataFragment
  )> }
);


export const GetAuthenticatedUserCompaniesDocument = /*#__PURE__*/ gql`
    query getAuthenticatedUserCompanies($companyId: ObjectID) {
  currentUser {
    ...CurrentUserCompaniesData
  }
}
    ${CurrentUserCompaniesDataFragmentDoc}
${UserCompanyContextDataFragmentDoc}
${TranslatedStringDataFragmentDoc}
${LanguagePackContextDataFragmentDoc}
${UploadFileWithPreviewFormDataFragmentDoc}
${AvailableModulesDataFragmentDoc}
${CompanyDealerDataFragmentDoc}
${MaintenanceUpdateFragmentDoc}
${SimpleVersioningDataFragmentDoc}
${AuthorDataFragmentDoc}
${UserAvatarSpecsFragmentDoc}
${EdmEmailFooterPublicDataFragmentDoc}
${EdmSocialMediaDataFragmentDoc}`;

/**
 * __useGetAuthenticatedUserCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedUserCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedUserCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedUserCompaniesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAuthenticatedUserCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthenticatedUserCompaniesQuery, GetAuthenticatedUserCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthenticatedUserCompaniesQuery, GetAuthenticatedUserCompaniesQueryVariables>(GetAuthenticatedUserCompaniesDocument, options);
      }
export function useGetAuthenticatedUserCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthenticatedUserCompaniesQuery, GetAuthenticatedUserCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthenticatedUserCompaniesQuery, GetAuthenticatedUserCompaniesQueryVariables>(GetAuthenticatedUserCompaniesDocument, options);
        }
export type GetAuthenticatedUserCompaniesQueryHookResult = ReturnType<typeof useGetAuthenticatedUserCompaniesQuery>;
export type GetAuthenticatedUserCompaniesLazyQueryHookResult = ReturnType<typeof useGetAuthenticatedUserCompaniesLazyQuery>;
export type GetAuthenticatedUserCompaniesQueryResult = Apollo.QueryResult<GetAuthenticatedUserCompaniesQuery, GetAuthenticatedUserCompaniesQueryVariables>;